// src/components/Calendar/EditDatesDialog.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Button,
} from '@mui/material';

export default function EditDatesDialog({
  open,
  vrm,
  values,
  onChangeField,
  onClose,
  onSave,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit PHV Dates for {vrm}</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Plate expiry"
            type="datetime-local"
            value={values.plateExpiry}
            onChange={(e) => onChangeField('plateExpiry', e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <TextField
            label="Interim test"
            type="datetime-local"
            value={values.interimTest}
            onChange={(e) => onChangeField('interimTest', e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <TextField
            label="Booking test"
            type="datetime-local"
            value={values.bookingTest}
            onChange={(e) => onChangeField('bookingTest', e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSave}>
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
